import { connect } from 'react-redux'

import { getLatestSdk } from '../store/actions/storage'
import DownloadSdkComponent from '../components/developerApi/developerSdk/DownloadSdk/DownloadSdkComponent'
import { SDK_LATEST } from '../constants/storage'
import { API_NAMES } from '../constants/common'

const mapStateToProps = ({ storage: { isLoading, files } }, { api }) => ({
    api,
    isLoading,
    sdk: files[`${api}.${SDK_LATEST}`] || {},
})

const mapDispatchToProps = {
    getLatestSdk,
}

const mergeProps = (
    { api, ...stateProps },
    { getLatestSdk },
) => {
    return {
        ...stateProps,
        title: `Download ${API_NAMES[api]} SDK`,
        content: `Download the latest ${API_NAMES[api]} SDK from Life Fitness Halosphere API.`,
        getLatestSdk: () => getLatestSdk(api),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DownloadSdkComponent)



// WEBPACK FOOTER //
// ./src/containers/DownloadSdkContainer.js